const binding = { modules: {}, dataActions: {} };

    (binding.modules['ml-carousel'] = {
        c: () => require('partner/modules/ml-carousel/ml-carousel.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ml-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ml-carousel'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ml-carousel|ml-carousel'] = {
                c: () => require('partner/modules/ml-carousel/ml-carousel.view.tsx'),
                cn: '__local__-__local__-ml-carousel'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };